












































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase';
import MailParserView from '@/components/mail/mailparser.vue';

@Component({
  components: {
    MailParserView
  },
})
export default class HzMailReadViews extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    title:string ="邮件查看";
    visibleChange(value) {
      if (!value) {
        (this.$refs["mailRef"] as any).resetFields();
        this.$emit('input',false);
      }
      else{
        //this.getItem();
      }
    }
    cancel(){
      (this.$refs["mailRef"] as any).resetFields();
      this.$emit('input',false);
    }
}
